import React, { useMemo } from 'react';
import { UserProfile } from '../../types';
import { FadeInContainer } from './HomeUI';

interface DashboardHeaderProps {
    userProfile?: UserProfile | null;
    boardsCount: number;
    sharedCount: number;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
    userProfile,
    boardsCount,
    sharedCount
}) => {
    const hour = new Date().getHours();
    const greeting = useMemo(() => {
        if (hour < 12) return 'Good morning';
        if (hour < 18) return 'Good afternoon';
        return 'Good evening';
    }, [hour]);

    const dateString = useMemo(() => {
        return new Date().toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'long',
            day: 'numeric'
        });
    }, []);

    const firstName = userProfile?.name?.split(' ')[0] || 'Explorer';

    return (
        <FadeInContainer className="mb-6">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
                <div>
                    <h1 className="text-2xl md:text-3xl font-black tracking-tight text-slate-900 dark:text-white mb-1">
                        {greeting}, <span className="text-indigo-500">{firstName}</span>
                    </h1>
                    <div className="flex items-center gap-3 text-xs font-medium text-slate-500 dark:text-slate-400">
                        <span>{dateString}</span>
                        <span className="w-1 h-1 rounded-full bg-slate-300 dark:bg-slate-700" />
                        <span className="text-slate-700 dark:text-slate-300">
                            <span className="font-bold">{boardsCount}</span> active boards
                        </span>
                        {sharedCount > 0 && (
                            <>
                                <span className="w-1 h-1 rounded-full bg-slate-300 dark:bg-slate-700" />
                                <span className="text-indigo-600 dark:text-indigo-400">
                                    {sharedCount} shared
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </FadeInContainer>
    );
};
